import React from "react";

import { useTranslation } from "react-i18next";

import GoBack from "../../components/GoBack";
import ImagePicker from "../../../../../../components/ui/image-picker/ImagePicker";
import LinkPicker from "../../../../../../components/ui/link-picker/LinkPicker";
import ButtonGroup from "../../../../../../components/ui/button-group/ButtonGroup";
import Text from "../../../../../../components/ui/input/text/Input";
import { useImageSliderStore } from "../../../../../../stores/use-image-slider-store";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { DESIGNS_OPTIONS, IMAGE_SLIDER_PROP } from "./defaults";
import { BOOLEAN_OPTIONS } from "./options";

const ImageSliderOptions = () => {
  const { data, image, updateImage, updateImageMultipleProps, setImage } =
    useImageSliderStore((state) => ({
      data: state.data,
      image: state.image,
      updateImage: state.updateImage,
      updateImageMultipleProps: state.updateImageMultipleProps,
      setImage: state.setImage,
    }));

  const { t } = useTranslation();

  const showContent =
    (data.hasImagesTitle || data.hasImagesDescription) &&
    DESIGNS_OPTIONS.IMAGE_CONTENT.includes(data.design);

  return (
    <>
      <GoBack
        onClick={() => setImage(undefined)}
        content={t("selected-image-content")}
      />
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("image")}</SettingsOptionHeading>
        {/* <OptionContainer>
          <OptionContent> */}
        <ImagePicker
          image={image}
          onChange={({ link, source, focalPoint }) => {
            updateImageMultipleProps({
              id: image.id,
              value: { link, source, focalPoint },
            });
            // updateImage({
            //   id: image.id,
            //   key: IMAGE_SLIDER_PROP.LINK,
            //   value: link,
            // });
            // updateImage({
            //   id: image.id,
            //   key: IMAGE_SLIDER_PROP.SOURCE,
            //   value: source,
            // });
          }}
          hasImageReposition
        />
        {/* </OptionContent>
        </OptionContainer> */}
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("link")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel alignToTop>{t("link-to")}</OptionLabel>
          <OptionContent>
            <LinkPicker
              value={image?.[IMAGE_SLIDER_PROP.LINK_TO_PAGE]}
              onChange={(value) => {
                updateImage({
                  id: image.id,
                  key: IMAGE_SLIDER_PROP.LINK_TO_PAGE,
                  value: {
                    ...image[IMAGE_SLIDER_PROP.LINK_TO_PAGE],
                    ...(value || { link: "" }),
                  },
                });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel>{t("new-tab")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={
                image?.[IMAGE_SLIDER_PROP.LINK_TO_PAGE]?.[
                  IMAGE_SLIDER_PROP.NEW_TAB
                ]
              }
              onClick={(value) =>
                updateImage({
                  id: image.id,
                  key: IMAGE_SLIDER_PROP.LINK_TO_PAGE,
                  value: {
                    ...image[IMAGE_SLIDER_PROP.LINK_TO_PAGE],
                    [IMAGE_SLIDER_PROP.NEW_TAB]: value,
                  },
                })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      {showContent && (
        <SettingsOptionContainer>
          <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
          {data.hasImagesTitle && (
            <OptionContainer>
              <OptionLabel>{t("title")}</OptionLabel>
              <OptionContent>
                <Text
                  placeholder="Add..."
                  value={image[IMAGE_SLIDER_PROP.TITLE]}
                  onChange={(value) =>
                    updateImage({
                      id: image.id,
                      key: IMAGE_SLIDER_PROP.TITLE,
                      value,
                    })
                  }
                />
              </OptionContent>
            </OptionContainer>
          )}

          {data.hasImagesDescription && (
            <OptionContainer>
              <OptionLabel>{t("subtext")}</OptionLabel>
              <OptionContent>
                <Text
                  placeholder="Add..."
                  value={image[IMAGE_SLIDER_PROP.DESCRIPTION]}
                  onChange={(value) =>
                    updateImage({
                      id: image.id,
                      key: IMAGE_SLIDER_PROP.DESCRIPTION,
                      value,
                    })
                  }
                />
              </OptionContent>
            </OptionContainer>
          )}
        </SettingsOptionContainer>
      )}
    </>
  );
};

export default ImageSliderOptions;
